/* ==========================================================================
 * Aarja — Desktop Mega Menu
 * Triggers ([data-mega-trigger]) are rendered in Liquid.
 * This script only handles open/close interactions.
 * ========================================================================== */
(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 990px)';
  var OPEN_CLASS    = 'is-open';
  var ACTIVE_CLASS  = 'is-active';
  var desktopMQ     = window.matchMedia(DESKTOP_QUERY);

  /* Body-level backdrop */
  var backdrop = document.createElement('div');
  backdrop.className = 'aarja-mega-backdrop';
  document.body.appendChild(backdrop);

  function isDesktop() { return desktopMQ.matches; }

  function getPanel(pos) {
    return document.querySelector('[data-mega-panel="' + pos + '"]');
  }

  function openPanel(trigger, panel) {
    closeAll();
    panel.classList.add(OPEN_CLASS);
    trigger.classList.add(ACTIVE_CLASS);
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    backdrop.classList.add(ACTIVE_CLASS);
  }

  function closePanel(trigger, panel) {
    panel.classList.remove(OPEN_CLASS);
    trigger.classList.remove(ACTIVE_CLASS);
    panel.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    backdrop.classList.remove(ACTIVE_CLASS);
  }

  function closeAll() {
    document.querySelectorAll('[data-mega-panel].' + OPEN_CLASS).forEach(function (p) {
      p.classList.remove(OPEN_CLASS);
      p.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-mega-trigger].' + ACTIVE_CLASS).forEach(function (t) {
      t.classList.remove(ACTIVE_CLASS);
      t.setAttribute('aria-expanded', 'false');
    });
    backdrop.classList.remove(ACTIVE_CLASS);
  }

  function init() {
    var headerMenu = document.querySelector('header-menu');
    if (!headerMenu) return;

    /* Open on hover */
    headerMenu.addEventListener('mouseover', function (e) {
      if (!isDesktop()) return;
      var trigger = e.target.closest('[data-mega-trigger]');
      if (!trigger) return;
      var panel = getPanel(trigger.getAttribute('data-mega-trigger'));
      if (panel) openPanel(trigger, panel);
    });

    /* Close when leaving trigger (unless moving into panel) */
    headerMenu.addEventListener('mouseout', function (e) {
      if (!isDesktop()) return;
      var trigger = e.target.closest('[data-mega-trigger]');
      if (!trigger) return;
      var panel = getPanel(trigger.getAttribute('data-mega-trigger'));
      if (!panel) return;
      if (e.relatedTarget && panel.contains(e.relatedTarget)) return;
      closePanel(trigger, panel);
    });

    /* Close when leaving panel (unless returning to trigger) */
    headerMenu.addEventListener('mouseout', function (e) {
      if (!isDesktop()) return;
      var panel = e.target.closest('[data-mega-panel]');
      if (!panel) return;
      var pos     = panel.getAttribute('data-mega-panel');
      var trigger = headerMenu.querySelector('[data-mega-trigger="' + pos + '"]');
      if (e.relatedTarget && panel.contains(e.relatedTarget)) return;
      if (trigger && e.relatedTarget && trigger.closest('.menu-list__list-item').contains(e.relatedTarget)) return;
      if (trigger) closePanel(trigger, panel);
    });

    /* Click toggle */
    headerMenu.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      var trigger = e.target.closest('[data-mega-trigger]');
      if (!trigger) return;
      e.stopPropagation();
      var panel = getPanel(trigger.getAttribute('data-mega-trigger'));
      if (!panel) return;
      panel.classList.contains(OPEN_CLASS) ? closePanel(trigger, panel) : openPanel(trigger, panel);
    });

    /* Clicks inside panel don't close it */
    headerMenu.addEventListener('click', function (e) {
      if (e.target.closest('[data-mega-panel]')) e.stopPropagation();
    });
  }

  document.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  desktopMQ.addEventListener('change', function () { if (!isDesktop()) closeAll(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
 * Aarja — Mobile Drawer: position below announcement bar
 * ========================================================================== */
(function () {
  'use strict';

  function getAnnouncementHeight() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return 0;
    return Math.max(0, bar.getBoundingClientRect().bottom);
  }

  function applyOffset() {
    var panel = document.querySelector('.menu-drawer.aarja-mobile-drawer');
    if (!panel) return;
    var offset = getAnnouncementHeight();
    panel.style.top    = offset + 'px';
    panel.style.height = 'calc(100dvh - ' + offset + 'px)';
  }

  function resetOffset() {
    var panel = document.querySelector('.menu-drawer.aarja-mobile-drawer');
    if (!panel) return;
    panel.style.top    = '';
    panel.style.height = '';
  }

  function init() {
    var details = document.querySelector('#Details-menu-drawer-container');
    if (!details) return;

    var observer = new MutationObserver(function () {
      if (details.classList.contains('menu-open')) {
        applyOffset();
      } else {
        resetOffset();
      }
    });
    observer.observe(details, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('resize', function () {
      if (details.classList.contains('menu-open')) applyOffset();
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
